import React, {Component} from 'react';
import {Card, CardDeck} from "react-bootstrap";
import {getRoute} from "../breadcrumb/utils";
import screens from "../screens";
import img from "../static/img";
import Security from "../components/security";
import {withRouter} from "react-router-dom";
import {IconTitles} from "../components/iconTitle";
import {faFolderUser} from "@fortawesome/pro-solid-svg-icons";
import parse from "react-html-parser";

class BlockedStudent extends Component {
	spaces(sm, md, lg, xl) {

		let result = [];

		for (let i = sm; i % 2 !== 0; i++) {
			result.push(<div key={Math.random()}
							 style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
							 className="d-none d-sm-flex d-md-none d-lg-none d-xl-none"/>);
		}

		for (let i = md; i % 3 !== 0; i++) {
			result.push(<div key={Math.random()}
							 style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
							 className="d-none d-sm-none d-md-flex d-lg-none d-xl-none"/>);
		}

		for (let i = lg; i % 6 !== 0; i++) {
			result.push(<div key={Math.random()}
							 style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
							 className="d-none d-sm-none d-md-none d-lg-flex d-xl-none"/>);
		}

		for (let i = xl; i % 7 !== 0; i++) {
			result.push(<div key={Math.random()}
							 style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
							 className="d-none d-sm-none d-md-none d-lg-none d-xl-flex"/>);
		}

		return result;
	}

	render() {
		document.body.classList.add("pace-done");

		let app = [
			{
				name: "Mes documents",
				onClick: getRoute(screens.Documents),
				space: {sm: 0, md: 0, lg: 0, xl: 0},
				img: img.Documents
			},
			{
				name: "Valves électroniques",
				onClick: getRoute(screens.Valves),
				space: {sm: 0, md: 0, lg: 0, xl: 0},
				img: img.Valves
			},
		];

		app.forEach((part, index, array) => {
			if (typeof array[index].onClick === "string") {
				const value = array[index].onClick;
				array[index].onClick = () => {
					this.props.history.push(value);
				}
			}
		})

		let countSM = 0;
		let countMD = 0;
		let countLG = 0;
		let countXL = 0;

		const notifications = Security.getNotifications();
		const notification = notifications.nbDocuments > 0 ? (
			<span className={"notification"}>
                <span>{notifications.nbDocuments}</span>
            </span>
		) : (<></>);

		let header = [];
		if (Security.getUser().GestionnairesAdministratifs != null) header.push({icon: faFolderUser, type: "h5", content: parse("<small><u>Gestionnaire(s) administratif(s)</u></small> : " + Security.getUser().GestionnairesAdministratifs)});
		//if (Security.getUser().Coordinateurs != null) header.push({icon: faUserCheck, type: "h5", content: parse("<small><u>Coordinateur(s)</u></small> : " + Security.getUser().Coordinateurs)});

		return (
			<section>
				<div className={"text-center pb-5"}>
					<h2>Votre accès est limité pour raisons administratives.</h2>
					<h1>Contactez votre gestionnaire de dossier pour débloquer votre situation.</h1>
				</div>
				<div>
					<IconTitles titles={header}/>
				</div>
				<CardDeck className={"desktop pt-5"}>
					{app.map(function (a, key) {

						const customSpaces = function (length, type) {
							if (length > 0) {
								let result = [];

								for (let i = length; i > 0; i--) {
									result.push(<div
										key={Math.random()}
										style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
										className={`d-none d-sm-none d-md-none d-lg-none d-xl-none d-${type}-flex`}/>);

									switch (type) {
										case 'sm':
											countSM++;
											break;
										case 'md':
											countMD++;
											break;
										case 'lg':
											countLG++;
											break;
										case 'xl':
											countXL++;
											break;
										default:
											break;
									}

									result.push(jump(type));
								}

								return result;
							}
						}

						const jump = function (type) {
							let result = [];

							switch (type) {
								case 'sm':
									if (countSM !== 0 && countSM % 2 === 0) {
										result.push(<div
											key={Math.random()}
											className="w-100 my-2 d-none d-sm-block d-md-none d-lg-none d-xl-none"/>);
									}
									break;
								case 'md':
									if (countMD !== 0 && countMD % 3 === 0) {
										result.push(<div
											key={Math.random()}
											className="w-100 my-2 d-none d-sm-none d-md-block d-lg-none d-xl-none"/>)
									}
									break;
								case 'lg':
									if (countLG !== 0 && countLG % 6 === 0) {
										result.push(<div
											key={Math.random()}
											className="w-100 my-2 d-none d-sm-none d-md-none d-lg-block d-xl-none"/>)
									}
									break;
								case 'xl':
									if (countXL !== 0 && countXL % 7 === 0) {
										result.push(<div
											key={Math.random()}
											className="w-100 my-2 d-none d-sm-none d-md-none d-lg-none d-xl-block"/>)
									}
									break;
								default:
									break;
							}

							return result;
						}

						const update = function () {
							countSM++;
							countMD++;
							countLG++;
							countXL++;
						}

						return <React.Fragment key={Math.random()}>
							{a.space &&
								<>
									{customSpaces(a.space.sm, 'sm')}
									{customSpaces(a.space.md, 'md')}
									{customSpaces(a.space.lg, 'lg')}
									{customSpaces(a.space.xl, 'xl')}
								</>}
							<Card border={"primary"} onClick={a.onClick} key={key}>
								<Card.Body className={"text-center"}>
									{a.name === "Mes documents" && <>{notification}</>}
									{a.img && <Card.Img src={a.img}/>}
									<Card.Text className={"my-3"}>{a.name}</Card.Text>
								</Card.Body>
							</Card>

							{update()}
							{jump('sm')}
							{jump('md')}
							{jump('lg')}
							{jump('xl')}

						</React.Fragment>
					})}

					{this.spaces(countSM, countMD, countLG, countXL)}

				</CardDeck>
			</section>
		);
	}
}

export default withRouter(BlockedStudent);